import React from 'react'
import * as R from 'ramda'

import useAxios from 'hooks/useAxios'
import { Loader } from 'shared/components/Loader'
import IntegrationIndex from 'components/IntegrationIndex'
import ErrorBoundary from 'components/ErrorBoundary'
import { ErrorMessage } from 'components/ErrorMessage'
import { AdminContainer } from '../../'
import PageHeaderContainer from 'shared/components/PageHeader/container'

export default function AdminIntegrationIndexPage() {
  return (
    <React.Fragment>
      <PageHeaderContainer title="Integrations" />
      <AdminContainer>
        <div className="ui segment admin-section">
          <ErrorBoundary errorFallback={<ErrorMessage />}>
            <AdminIntegrationIndexContainer />
          </ErrorBoundary>
        </div>
      </AdminContainer>
    </React.Fragment>
  )
}

function AdminIntegrationIndexContainer() {
  const { data, loading } = useAxios({
    url: `cyclr/integrations/?domain=${window.location.host}`,
  })

  if (loading && data === undefined) {
    return <Loader withContainer />
  }

  const integrations = R.prop('integrations', data)
  if (integrations) {
    const sortByName = R.sortBy(R.compose(R.toLower, R.prop('name')))
    return <IntegrationIndex integrations={sortByName(integrations)} />
  }

  return null
}



// WEBPACK FOOTER //
// ./src/pages/Admin/Integrations/Index/index.tsx